import TransLink from "@/utils/TransLink";
import { ReactSVG } from "react-svg";
import arrowsearch from "@/assets/Arrowsearch.svg";
import locationlist from "@/assets/locationlist.svg";
import phone from "@/assets/phone.svg";
import { useState } from "react";
import Star from "./Star";
import stockimg from "@/assets/stockimg.png";
import { useTranslation } from "react-i18next";
import { ResultItem } from "@/types";


import calendar from "@/assets/calendar.svg"
import { Link } from "@heroui/react";
import { AnimatePresence, motion } from "framer-motion";

const ItemCard = ({ item }: { item: ResultItem }) => {

    const { t } = useTranslation(["glossary"])
    
    const CATEGORY_COLORS = {
        Activity: "#890077",
        Place: "#00668A",
        Event: "#006E0F",
        Accomodation: "#704700",
        Business: "#5600AD",
    };
    const [openBubble, setOpenBubble] = useState(null);

    return (
        <div className="flex flex-col border-b border-r border-l rounded-md">
            <div className="rounded-xl relative">
                {/* Overlay */}

                <div
                    className="absolute flex flex-row w-full h-full rounded-xl text-white"
                >
                    <div className="absolute bottom-4 z-10 mx-4 flex items-center space-x-4">
                        <Star item={item} />

                        {item.mobile && (
                            <div className="relative">
                                <Link
                                    href={`tel:${item.mobile}`}
                                    title={t('contact')}
                                    onMouseEnter={() =>
                                        setOpenBubble(
                                            openBubble === item ? null : item,
                                        )
                                    }
                                    onMouseLeave={() => {
                                        setOpenBubble(null)
                                    }}
                                    className="border-2 hover:bg-[#1D26CA] hover:border-[#1D26CA] flex items-center px-3 rounded-md transition"
                                >
                                    <ReactSVG
                                        src={phone}
                                        className="w-8 h-8 rounded-md text-white mr-2 p-1"
                                        beforeInjection={(svg) => {
                                            svg.setAttribute(
                                                "style",
                                                "width: 24px; height: 24px;",
                                            );
                                            svg.querySelectorAll(
                                                "path",
                                            ).forEach((path) => {
                                                path.setAttribute(
                                                    "fill",
                                                    "currentColor",
                                                );
                                            });
                                        }}
                                    />

                                    <div className="text-white font-medium">
                                        {t('contact')}
                                    </div>
                                </Link>
                                <AnimatePresence>
                                    {openBubble === item && (
                                        <motion.div initial={{ y: 10, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 10, opacity: 0 }} className="absolute left-6 bottom-10 mb-2 flex flex-col items-center">
                                            <span className="relative z-10 p-2 leading-none text-white whitespace-no-wrap bg-[#1D26CA] shadow-lg rounded-md">
                                                {item.mobile}
                                            </span>
                                            <div className="w-3 h-3 -mt-2 rotate-45 bg-[#1D26CA]"></div>
                                        </motion.div>
                                    )}
                                </AnimatePresence>
                            </div>
                        )}
                    </div>
                </div>

                <img
                    className="h-[220px] w-full object-cover rounded-lg brightness-50"
                    src={item.image === null ? stockimg : item.image}
                />

            </div>

            <TransLink className="h-full" url={`${item.slug.prefix}/${item.slug.key}`}>
                <div className="p-3 h-full flex flex-col justify-between gap-2">
                    <h2 className="text-xl font-semibold mb-2">{item.name}</h2>

                    <p className="text-black line-clamp-6 mb-4 text-[10px]">
                        {item.description}
                    </p>

                    {item.model === 'Event' &&
                        <div className="flex items-center gap-2">
                            <img className="size-4" src={calendar} />
                            <p className="text-[10px]">{item?.start_date} - {item?.end_date}</p>
                        </div>
                    }
                    <div className="flex flex-wrap justify-between items-center gap-4">

                        <div className="text-sm font-semibold flex items-center">
                            <ReactSVG
                                src={locationlist}

                                beforeInjection={(svg) => {
                                    svg.setAttribute(
                                        "style",
                                        "width: 17px; height: 17px;",
                                    );
                                    svg.querySelectorAll("path").forEach(
                                        (path) => {
                                            path.setAttribute(
                                                "fill",
                                                CATEGORY_COLORS[item.model] ||
                                                "currentColor",
                                            );
                                        },
                                    );
                                }}
                            />
                            <span className="ml-2 text-xs font-bold ">{item.name}</span>
                        </div>

                        {item.model === "Accomodation" && item.can_reservation && (
                            <a
                                title={t('book_now')}
                                href=""
                                className="border hover:bg-[#1D24CA] hover:text-white rounded-full flex items-center bg-white text-[#1D24CA] justify-center transition"
                            >
                                <div className="mx-4 font-semibold text-xs">
                                    {t('book_now')}
                                </div>
                                <span>
                                    <ReactSVG
                                        src={arrowsearch}
                                        className="size-6"
                                        beforeInjection={(svg) => {
                                            svg.setAttribute(
                                                "style",
                                                "width: 100%; height:  100%;",
                                            );
                                            svg.querySelectorAll(
                                                "path",
                                            ).forEach((path) => {
                                                path.setAttribute(
                                                    "fill",
                                                    "currentColor",
                                                );
                                            });
                                        }}
                                    />
                                </span>
                            </a>
                        )}

                    </div>
                </div>
            </TransLink>
        </div>
    );
};

export default ItemCard;
